import { HARDCODED_MEDIA } from '../../../utils/hardcodedMediaConfig';

export const buildAuthTemplatePayload = (formData) => ({
  templateName: formData.name,
  category: formData.category,
  language: formData.language,
  isAuthTemplate: true,
  messageSendTtlSeconds: formData.messageSendTtlSeconds,
  addSecurityRecommendation: formData.addSecurityRecommendation,
  codeExpirationMinutes: formData.codeExpirationMinutes,
  otpType: formData.otpType,
  otpButtonText: formData.otpButtonText,
});

export const buildRegularTemplatePayload = (formData, mediaState) => {
  let headerType = 'none';

  if (formData.headerText && formData.headerText.trim()) {
    headerType = 'text';
  } else if (mediaState.mediaType && mediaState.mediaType !== 'none') {
    headerType = mediaState.mediaType;
  }

  let mediaFileToUse = null;

  if (headerType === 'image') {
    mediaFileToUse = HARDCODED_MEDIA.image;
  } else if (headerType === 'video') {
    mediaFileToUse = HARDCODED_MEDIA.video;
  } else if (headerType === 'document') {
    mediaFileToUse = HARDCODED_MEDIA.document;
  } else if (headerType === 'audio') {
    mediaFileToUse = HARDCODED_MEDIA.audio;
  } else {
    mediaFileToUse = mediaState.mediaFile;
  }

  return {
    templateName: formData.name,
    category: formData.category,
    language: formData.language,
    headerType,
    headerText: formData.headerText,
    templateBody: formData.bodyText,
    variableSamples: formData.sampleValues,
    mediaType: mediaState.mediaType,
    mediaFile: mediaFileToUse,
    buttons: mapButtonsForPayload(formData.buttons)
  };
};

const mapButtonsForPayload = (buttons = []) => {
  if (!Array.isArray(buttons) || buttons.length === 0) return undefined;

  return buttons.map((b) => {
    if (b.type === 'URL') {
      const urlObj = {
        type: 'URL',
        text: b.text,
        url: b.url,
      };
      if (b.urlType === 'DYNAMIC' && b.urlExample) urlObj.url_example = b.urlExample;
      return urlObj;
    }

    if (b.type === 'CALL') {
      const raw = String(b.phoneNumber || '').trim();
      let phoneNumber = raw;

          if (!phoneNumber.startsWith('+')) {
            // For now always use India dial code +91
            const prefix = '+91';
            const cleaned = phoneNumber.replace(/^0+/, '').replace(/[^0-9]/g, '');
            phoneNumber = `${prefix}${cleaned}`;
          }

      return {
        type: 'PHONE_NUMBER',
        text: b.text,
        phone_number: phoneNumber
      };
    }

    if (b.type === 'COPY') {
      return {
        type: 'COPY_CODE',
        text: 'Copy offer code',
        example: b.sample || ''
      };
    }

    if (b.type === 'QUICK_REPLY') {
      return {
        type: 'QUICK_REPLY',
        text: b.text,
      };
    }

    return null;
  }).filter(Boolean);
};
